import { Link } from "@inertiajs/react"
import { ArrowRight } from "lucide-react"
import { useTranslation } from "react-i18next"

import { creatorFeedPath } from "@/routes"

/**
 * OKS-474 / OKS-509 — §18 "See the feed →" link (UX Spec §2.5 / §4).
 *
 * The §10 Crew Feed shipped in OKS-509, so this is now a LIVE Inertia `<Link>`
 * to `/feed` (was an OKS-474 disabled stub while the destination didn't exist).
 *
 * Locked testid: `crew-feed-link`.
 */
export function CrewFeedLink() {
  const { t } = useTranslation()

  return (
    <Link
      href={creatorFeedPath()}
      data-testid="crew-feed-link"
      className="text-primary inline-flex items-center gap-1 text-sm font-medium hover:underline"
    >
      {t("crew_hub.roster.see_feed")}
      <ArrowRight aria-hidden="true" className="size-4" />
    </Link>
  )
}
